/* PP · Kopf – Kopfzeile beim Scrollen schlanker, Aufklapp-Menü ausrichten, breites Suchfeld (klappt am PC als Horizons Suchfenster auf),
   Telefon im Kopf + Service-Teil im Handy-Menü, Menü-Gruppen am Handy offen, dazu seitenweite Kleinigkeiten
   (Sie-Anrede im Warenkorb-Titel, Zifferntastatur in Mengenfeldern, Ersatz-Alt-Text fürs Startbild, Streifen-Vorschau ?pp-streifen=1).
   Wo benutzt: sections/pp-global.liquid (Kopf-Gruppe = jede Seite)      Abschaltbar: nein (gehört zur Kopfzeile)
   Liest: PP.kontakt() (pp-basis.js ← #pp-werte); Aussehen in assets/pp-global.css (Klassen pp-rollt / pp-gerollt / pp-menue-auf / pp-such-anker /
          pp-buntstreifen am <html>, Werte --pp-roll / --pp-anteil / --pp-zeile / --pp-menue-links / --pp-such-*)
   Horizon-Stellen: .header__row--top / --bottom, .header-logo, .header__column--left, header-actions, .menu-list__list-item, .mega-menu__list / __grid,
          .menu-drawer__utility-links, .menu-drawer__list-item--deep, dialog.search-modal__content (.search-input), search-button / .search-action,
          .hero img; aus pp-start: [data-pp-suche-auf]
   Fehlt eine Stelle: dieser Teil tut nichts (kein Fehler). Braucht: pp-basis.js (vorher geladen)
   Katalog: shop/baukasten/bausteine.md · Stand: 2026-10-25 (Startseiten-Überschrift steht jetzt in sections/header.liquid, A-0107 5.1; 24.10.: Rollposition je Bild statt Sicherheitsnetz alle 400 ms; C4 Schritt 3: aus assets/pp-global.js Abschnitt 1, 2, 3, 3b, 3c, 6, 8 + Menü-Gruppen) */
(function () {
  var PP = window.PP;
  if (!PP || !PP.erstesMal || !PP.erstesMal('kopf')) return; // ohne pp-basis.js nichts tun; nur einmal einrichten
  var html = document.documentElement;

  // 1 · Kopfzeile beim Scrollen schlanker: Logo kleiner, Menüzeile klappt ein, links erscheint der Knopf „Sortiment“.
  //     Aussehen in pp-global.css (Klassen pp-gerollt / pp-menue-auf am <html>).
  var zuletzt = null;
  // In der Theme-Vorschau rollt nicht das Fenster, sondern ein Rahmen (.page-wrapper) → beides berücksichtigen
  function stand() {
    var rahmen = document.querySelector('.page-wrapper');
    return Math.max(window.pageYOffset || 0, html.scrollTop || 0, document.body ? document.body.scrollTop : 0, rahmen ? rahmen.scrollTop : 0);
  }
  // 3. Fassung: kein Umschalten mehr – die Menüzeile rollt genau mit der Seite weg (so viele Pixel, wie gerollt wurde,
  // höchstens ihre eigene Höhe). --pp-roll = Pixel, --pp-anteil = 0 … 1 (für Logo-Größe und die drei Striche).
  var zeile = 43;
  function rollen() {
    var y = stand(), roll = Math.max(0, Math.min(y, zeile));
    if (roll === zuletzt) return;
    zuletzt = roll;
    html.style.setProperty('--pp-roll', roll + 'px');
    html.style.setProperty('--pp-anteil', (roll / zeile).toFixed(3));
    html.classList.toggle('pp-rollt', roll > 0);
    html.classList.toggle('pp-gerollt', roll >= zeile);
    if (roll < zeile) html.classList.remove('pp-menue-auf');
  }
  // 24.10.2026 (Tempo-Stand): Lesen der Rollposition nur noch einmal je Bild (requestAnimationFrame) statt bei jedem Scroll-Ereignis; das Sicherheitsnetz
  // setInterval(rollen, 400) ist weg – es las auch mitten im Laden und erzwang so jedes Mal Layout (Handy Startseite 269 ms Zwangs-Layout,
  // entwuerfe/2026-10/2026-10-24_theme-tempo-stand). Die Rahmen-Vorschau (.page-wrapper rollt) meldet ihr Rollen über den capture-Listener am document.
  var geplant = false;
  function rollenBald() { if (geplant) return; geplant = true; (window.requestAnimationFrame || setTimeout)(function () { geplant = false; rollen(); }); }
  window.addEventListener('scroll', rollenBald, { passive: true });
  document.addEventListener('scroll', rollenBald, { passive: true, capture: true });
  window.addEventListener('resize', rollenBald);

  function knopf() {
    if (document.querySelector('.pp-menueknopf')) return;
    var logo = document.querySelector('.header__row--top .header-logo');
    if (!logo || !logo.parentNode) return;
    var k = document.createElement('button');
    k.type = 'button';
    k.className = 'pp-menueknopf';
    k.setAttribute('aria-label', 'Sortiment anzeigen');
    k.innerHTML = '<svg width="20" height="14" viewBox="0 0 20 14" aria-hidden="true"><path d="M1 1h18M1 7h18M1 13h18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    logo.parentNode.insertBefore(k, logo.nextSibling); // rechts neben dem Logo – das Logo bleibt ganz links an seinem Platz
  }
  // Höhe der Menüzeile merken (nur im ausgeklappten Zustand messen) → CSS gleicht sie beim Einklappen aus, nichts springt
  function zeileMessen() {
    var z = document.querySelector('.header__row--bottom');
    if (!z || html.classList.contains('pp-rollt')) return; // nur ganz oben messen, wenn die Zeile voll zu sehen ist
    var h = z.getBoundingClientRect().height;
    if (h > 10) { zeile = Math.round(h); html.style.setProperty('--pp-zeile', zeile + 'px'); zuletzt = null; }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.pp-menueknopf')) html.classList.toggle('pp-menue-auf');
  });

  // 2 · Aufklapp-Menü: Karte unter den Menüpunkt rücken, über dem die Maus ist.
  //     Das Theme tauscht Teile der Kopfzeile nachträglich aus → am Dokument lauschen, nicht an einzelnen Elementen.
  function ausrichten(punkt) {
    var liste = punkt.querySelector('.mega-menu__list'), raster = punkt.querySelector('.mega-menu__grid');
    if (!liste || !raster) return;
    var r = raster.getBoundingClientRect();
    var links = punkt.getBoundingClientRect().left - r.left;
    var max = Math.max(0, r.width - 340);
    // am <html> merken (es ist immer nur ein Menü offen) – am Element selbst löscht das Theme die Angabe wieder
    html.style.setProperty('--pp-menue-links', Math.max(0, Math.min(links, max)) + 'px');
  }
  function beiPunkt(e) {
    var p = e.target && e.target.closest ? e.target.closest('.menu-list__list-item') : null;
    if (p) ausrichten(p);
  }
  document.addEventListener('pointerover', beiPunkt, true);
  document.addEventListener('focusin', beiPunkt, true);

  // 3 · Breites Suchfeld in der Kopfzeile (wie in der Vorlage). Es ist ein Knopf im Aussehen eines Eingabefelds: ein Klick
  //     öffnet die Suche des Themes (mit Vorschlägen beim Tippen) – so gibt es nur EINE Suche, und nichts wird doppelt gepflegt.
  function suchfeld() {
    if (document.querySelector('.pp-suchfeld')) return;
    var links = document.querySelector('.header__row--top .header__column--left');
    if (!links) return;
    var f = document.createElement('button');
    f.type = 'button';
    f.className = 'pp-suchfeld';
    f.setAttribute('aria-label', 'Suche öffnen');
    f.innerHTML = '<span>Suchen, z. B. Karton 20 × 20<span class="pp-suchfeld__mehr"> oder Artikelnummer</span></span><svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="5.5" stroke="currentColor" stroke-width="1.6"/><path d="M13.5 13.5L17 17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    links.appendChild(f);
  }

  // 3b · Kopf D (Umbau D, Paket 2, 25.09.2026): Telefon im Kopf am PC (CSS zeigt es ab 1.000 px) und ein Service-Teil unten im
  //      Handy-Menü. Die Lupe am Handy rechts neben dem Warenkorb regelt nur pp-global.css.
  function kopfD() {
    var aktionen = document.querySelector('.header__row--top header-actions') || document.querySelector('header-actions');
    // Beratung steht in der Suchzeile (Nutzer 25.09.2026: eigene Service-Leiste über dem Kopf machte die Kopfzeile zu hoch; Leiste in C4 Schritt 1
    // entfernt), Text „Persönliche Beratung“ + Nummer bei jeder Breite, ohne Zeitangaben.
    var kt = PP.kontakt(); // Nummer aus pp-werte – ohne Nummer kein Kopf-Telefon und kein Anruf-Link im Service-Menü
    if (aktionen && kt.tel && kt.link && !document.querySelector('.pp-kopftel')) {
      var t = document.createElement('a'); t.className = 'pp-kopftel'; t.href = 'tel:' + kt.link;
      // Nutzer 25.09.2026 („telefonnummer sieht einfach unpassend eingereiht aus“): zweizeilig – klein „Persönliche Beratung“, darunter die Nummer.
      // Nutzer 25.09.2026 („sieht noch sehr hart aus … freundlicher, ohne dass es in den hintergrund rückt“): Hörer im warmen Kreis, Nummer
      // normal statt fett, dafür eine Stufe größer.
      t.setAttribute('aria-label', 'Persönliche Beratung anrufen: ' + kt.tel);
      t.title = 'Persönliche Beratung';
      t.innerHTML = '<span class="pp-kopftel__kreis" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span><span class="pp-kopftel__text"><small>Persönliche Beratung</small><b>' + kt.telHtml + '</b></span>';
      aktionen.parentNode.insertBefore(t, aktionen);
    }
    // Lupe: Horizon hat rechts schon eine zweite (am Handy ausgeblendet) – die zeigt pp-global.css am Handy, die linke wird ausgeblendet
    var unten = document.querySelector('.menu-drawer__utility-links');
    if (unten && !unten.querySelector('.pp-service')) {
      var s = document.createElement('div'); s.className = 'pp-service';
      s.innerHTML = '<p class="pp-service__titel">Service</p>' +
        (kt.tel && kt.link ? '<a class="pp-service__tel" href="tel:' + kt.link + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>Anrufen: ' + kt.telHtml + '</a>' : '') +
        '<a href="/pages/versandinfo">Versand &amp; Zahlung</a><a href="/pages/faq">Häufige Fragen</a><a href="/pages/kontakt">Kontakt</a><a href="/pages/uber-uns">Über uns</a>';
      unten.appendChild(s);
    }
  }
  // 3c · Nutzer 25.09.2026 („wenn man in die suchleiste klickt … öffnet sich ein 2. fenster wo nochmal eine suchleiste auftaucht … ich hätte
  //      lieber dass die eigentliche suchleiste aufklappt“): Am PC legt sich Horizons Suchfenster genau auf das Feld im Kopf (Klasse
  //      pp-such-anker + Lage als CSS-Werte, Aussehen in pp-global.css) – es sieht aus, als klappe das Feld auf. Am Handy bleibt die Suche
  //      bildschirmfüllend (üblich, nur ein Feld zu sehen).
  function sucheAnFeld(feld) {
    var r = feld.getBoundingClientRect(), h = document.documentElement;
    var breite = Math.min(Math.max(r.width, 560), window.innerWidth - r.left - 16);
    h.style.setProperty('--pp-such-l', r.left + 'px'); h.style.setProperty('--pp-such-t', r.top + 'px');
    h.style.setProperty('--pp-such-b', breite + 'px'); h.style.setProperty('--pp-such-h', r.height + 'px');
    h.classList.add('pp-such-anker');
    var text = (feld.textContent || '').replace(/\s+/g, ' ').trim();
    setTimeout(function () { var i = document.querySelector('dialog.search-modal__content .search-input'); if (i && text && !i.value) i.placeholder = text; }, 60);
  }
  document.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('dialog.search-modal__content')) document.documentElement.classList.remove('pp-such-anker');
  }, true);
  window.addEventListener('resize', function () {
    if (!document.documentElement.classList.contains('pp-such-anker')) return;
    var f = document.querySelector('.pp-suchfeld'); if (f && f.getBoundingClientRect().width > 0) sucheAnFeld(f); else document.documentElement.classList.remove('pp-such-anker');
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.pp-suchfeld, [data-pp-suche-auf]')) return; // Umbau D: auch das Suchfeld der Startseite (Handy, pp-start)
    var feld = e.target.closest('.pp-suchfeld');
    if (feld && feld.getBoundingClientRect().width > 0) sucheAnFeld(feld); else document.documentElement.classList.remove('pp-such-anker');
    var theme = document.querySelector('search-button button, .search-action button');
    if (theme) theme.click(); else window.location.href = '/search';
  });

  // 6 · Analyse-Lauf 2 (22.09.2026): Sie-Anrede im Browser-Titel des Warenkorbs (Shopify liefert „Dein Warenkorb“, nicht im
  //     Theme änderbar) und Zifferntastatur am Handy für alle Mengenfelder (inputmode).
  //     (Die Info-Zeilen unter „Zur Kasse“ setzt seit 03.10.2026 Liquid – snippets/pp-korb-hinweis; der alte Skript-Ersatz ist entfallen.)
  function kleinkram() {
    if (/^Dein Warenkorb/.test(document.title)) document.title = document.title.replace(/^Dein Warenkorb/, 'Ihr Warenkorb');
    var felder = document.querySelectorAll('input[type="number"]:not([inputmode])');
    for (var i = 0; i < felder.length; i++) felder[i].setAttribute('inputmode', 'numeric');
    // Startbild: Alt-Text kommt aus Inhalte → Dateien (dort noch leer, To-do) – bis dahin Ersatztext
    var hero = document.querySelectorAll('.hero img:not([alt]), .hero img[alt=""], [class*="hero"] img[alt=""]');
    for (var j = 0; j < hero.length; j++) hero[j].setAttribute('alt', 'Bunte Geschenkkartons und Verpackungen von packpower');
  }

  // Option „bunter Streifen im Kopf“ (26.09.2026, noch NICHT eingeschaltet): Vorschau auf jeder Seite mit ?pp-streifen=1 (CSS in pp-global.css)
  if (/[?&]pp-streifen=1/.test(location.search)) document.documentElement.classList.add('pp-buntstreifen');

  // 30.09.2026 (Kontrollgang S-02, Entscheidung Nutzer): Menü „Bänder & Schleifen“ hat zwei Gruppen („Bänder“, „Karten & Aufkleber“) – am Handy
  // stehen solche Gruppen (3. Ebene) von Anfang an offen, sonst bräuchte man für „Ringelbänder“ einen Tipp mehr als vorher
  function menueGruppenAuf() { var d = document.querySelectorAll('.menu-drawer__list-item--deep > accordion-custom > details'); for (var i = 0; i < d.length; i++) if (!d[i].__pp) { d[i].open = true; d[i].__pp = true; } }

  window.addEventListener('resize', zeileMessen);
  PP.beimStart(10, knopf);
  PP.beimStart(20, suchfeld);
  PP.beimStart(30, kopfD);
  PP.beimStart(40, zeileMessen);
  PP.beimStart(50, rollen);
  PP.beimStart(70, kleinkram);
  PP.beimStart(160, menueGruppenAuf);
})();
